class Drawer {
  constructor({
    drawerID,
    buttonID,
    onToggle,
    onDomLoaded,
    drawerAnimations = { enter: { x: ['0%', '100%'] }, exit: { x: ['100%', '0%'] } },
  }) {
    this.id = drawerID;
    this.drawerAnimations = drawerAnimations;
    this.buttonID = buttonID;
    this.isDrawerOpen = false;
    this.animationInProgress = false;
    this.onToggle = onToggle;
    const initDOM = () => {
      this.button = this.buttonID ? document.getElementById(this.buttonID) : null;
      this.drawer = document.getElementById(this.id);
      this.drawer.toggleDrawer = this.toggle.bind(this);
      this.drawer.setAttribute('data-drawer-open', `${this.isDrawerOpen}`);
      if (this.button) {
        this.button.setAttribute('data-drawer-open', `${this.isDrawerOpen}`);
        this.button.addEventListener('click', () => {
          this.toggle();
        });
      }
      onDomLoaded?.(this.drawer, this.button);
      this.drawer.addEventListener('toggleDrawer', this.onToggle);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDOM);
    } else {
      initDOM();
    }
  }
  async toggle() {
    const drawerAnimation = !this.isDrawerOpen ? this.drawerAnimations.enter : this.drawerAnimations.exit;
    const { animate } = window.Motion;

    if (this.animationInProgress) return;

    this.animationInProgress = true;
    this.isDrawerOpen = !this.isDrawerOpen;
    this.drawer.setAttribute('data-drawer-open', `${this.isDrawerOpen}`);
    if (this.button) {
      this.button.setAttribute('data-drawer-open', `${this.isDrawerOpen}`);
    }
    await animate(this.drawer, drawerAnimation, { duration: 0.4, ease: !this.isDrawerOpen ? 'easeOut' : 'easeIn' });
    this.animationInProgress = false;
    this.toggleEvent = new CustomEvent('toggleDrawer', {
      detail: {
        drawerID: this.id,
        buttonID: this.buttonID,
        button: document.getElementById(this.buttonID),
        drawer: document.getElementById(this.id),
        isOpen: this.isDrawerOpen,
      },
    });
    this.drawer.dispatchEvent(this.toggleEvent);
  }
}
